<template>
  <div class="mack" v-if="isShow">
    <div class="tipbox">
      <div class="title">
        {{settingObj.title}}
        <span class="colse-layer">
          <button class="colse-layer-ico" @click="morcancel"></button>
        </span>
      </div>
      <div class="content-layer">
        <div class="content-icon" :class="'icon-type-' + settingObj.mtype"></div>
        <span>{{settingObj.content}}</span>
        <span v-if="settingObj.mtype==3" class="content-click" @click="morgoto">{{settingObj.clickContent}}</span>
      </div>
      <div class="tipbtn-layer">
        <button
          type="button"
          :class="'tipbtn-' + index"
          v-for="(item, index) in settingObj.btn"
          v-bind:key="index"
          @click="morhandle(index)"
        >
          {{item}}
        </button>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      isShow: true,
      settingObj: {
        title: "",
        content: "",
        clickContent: "", // 可点击的内容
        btn: [], // 底部操作按钮
        mtype: -1
      },
    };
  },
  methods: {
    morhandle(index){
        if(index==0){
            this.morconfirm();
        }else if(index==1){
            this.morcancel();
        }
    },
    morconfirm() {
      this.isShow = false;
    },
    morcancel() {
      this.isShow = false;
    },
    morgoto(){
       this.isShow = false; 
    }
  },
};
</script>
 
<style scoped src="./Morconfirm.css"></style>


